import { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "kocm_cart_v2";
const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, variant, quantity = 1) => setItems((prev) => {
    const key = `${product.id}-${variant.id}`;
    const category = product.category || "research";
    const i = prev.findIndex((x) => x.key === key);
    if (i >= 0) {
      const next = [...prev];
      next[i] = { ...next[i], category, quantity: Math.min(100, next[i].quantity + quantity), price_cents: variant.price_cents, image_id: product.images?.[0]?.id || null };
      return next;
    }
    return [...prev, { key, category, product_id: product.id, variant_id: variant.id, name: product.name, size: variant.strength, form: product.form || "", price_cents: variant.price_cents, image_id: product.images?.[0]?.id || null, quantity: Math.min(100, quantity) }];
  });
  const remove = (key) => setItems((prev) => prev.filter((x) => x.key !== key));
  const setQty = (key, q) => setItems((prev) => prev.map((x) => (x.key === key ? { ...x, quantity: Math.min(100, Math.max(1, q)) } : x)));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const subtotal_cents = items.reduce((s, x) => s + x.price_cents * x.quantity, 0);
    const count = items.reduce((s, x) => s + x.quantity, 0);
    const hasResearch = items.some((x) => (x.category || "research") === "research");
    return { items, add, remove, setQty, clear, subtotal_cents, count, hasResearch };
  }, [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const c = useContext(CartContext);
  if (!c) throw new Error("useCart must be used within CartProvider");
  return c;
}

export function money(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}
